// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1gm8a","info":"PatientInfo_info__2Q8zP"};